import { render, staticRenderFns } from "./ChatMessageElement.vue?vue&type=template&id=5ba28773&scoped=true"
import script from "./ChatMessageElement.vue?vue&type=script&lang=js"
export * from "./ChatMessageElement.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageElement.vue?vue&type=style&index=0&id=5ba28773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba28773",
  null
  
)

export default component.exports